import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "api_list",
  "use": "api_list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"api_list\"><g fill-rule=\"evenodd\"><path d=\"M15 14a1 1 0 01-1 1H2a1 1 0 01-1-1V3.008h14V14zM2 0C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H2z\" /><path d=\"M7 6h6V5H7zM7 9h6V8H7zM7 12h6v-1H7zM3 12h2V5H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id